import { nerdNetworkBaseQuery } from "@nerdjs/nerd-network";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseApi";

export const mercuryApi = createApi({
  reducerPath: "mercuryApi",
  baseQuery: (args, api) => baseQuery(args, api, { service: "mercury" }),
  endpoints: () => ({}),
  tagTypes: ["stages", "pipelines", "interactors"],
});
